/** Mirrors b4s-server TeacherLeave.LEAVE_TYPES — keep in sync when server changes */
export const TEACHER_LEAVE_TYPES = [
  "Casual",
  "Sick",
  "Earned",
  "Maternity",
  "Paternity",
  "CompOff",
  "OnDuty",
  "Unpaid",
  "Other",
];
